<template>
<v-app id="inspire">
  <v-dialog v-model="this.$store.getters['hasError']" persistent max-width="390">
      <v-card>
        <v-card-title class="error white--text v-card__title headline">{{ $t('ctrl.error') }}</v-card-title>
        <v-card-text class="v-card__text">{{ $t('ctrl.errorCode') }}: {{ this.$store.getters['errorCode'] }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="closeErrorDialog">{{ $t('ctrl.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app-bar
      app
      clipped-left
      color="primary"
      dark
      extended :extension-height="4"
      height="50"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-icon v-if="isLocalhost" class="ml-3" color="yellow">developer_mode</v-icon>
      <v-icon v-if="$store.getters['serverUnavailable']" class="ml-3" color="yellow">sync_problem</v-icon>
      <div class="flex-grow-1"></div>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span><flag :iso="$i18n?$i18n.locale.split('-')[1]:''" /></span>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="item in Object.keys(this.$i18n.messages)"
            :key="item"
            @click="$i18n.locale = item">
            <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon v-on:click="toggleDark">
        <v-icon>highlight</v-icon>
      </v-btn>
      <v-btn icon v-on:click="logout">
        <v-icon>logout</v-icon>
      </v-btn>
      <v-progress-linear v-if="$store.getters['loading']" slot="extension" :indeterminate="true" class="ma-0" color="accent" :height="4"></v-progress-linear>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item>
              <v-list-item-avatar>
                  <img src="/avatar.png">
              </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ this.userFullName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list>
      <v-select 
        :items="this.$store.getters['competitions']" :label="$t('ctrl.selectCompetition')" 
        v-model="selectedCompetition" solo item-value="id" class="pt-4">
        <template v-slot:item="i">
          <v-icon v-if="!i.item.public" color="primary">mdi-domino-mask</v-icon>
          {{ i.item.title }}
        </template>
        <template v-slot:selection="i">
          <v-icon v-if="!i.item.public" color="primary">mdi-domino-mask</v-icon>
          {{ i.item.title }}
        </template>
      </v-select>
        <v-list>
          <v-list-item value="true" v-for="(item, i) in this.items" :key="i" @click="navigate(item)">
            <v-list-item-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.key+'.title') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view :class="{'ma-1': $vuetify.breakpoint.smAndDown, 'ma-4': $vuetify.breakpoint.mdAndUp}" />
    </v-content>
  </v-app>
</template>

<script>
import {
    VCard,
    VCardActions,
    VCardTitle,
    VCardText,
    VDialog,
    VMenu,
    VSelect,
    VProgressLinear
} from 'vuetify/lib'
import fccapi from './fccapi.js'

export default {
  name: 'Layout',
  data () {
    return {
      drawer: true,
      fixed: false,
      right: true,
      rightDrawer: false,
      title: 'Dashboard',
      competitions: []
    }
  },
  computed: {
    competitionNames: function() {
      return this.$store.getters['competitions'].map(c => c.title);
    },
    localeCountry: function() {
      return this.$i18n.locale.split('-')[1]
    },
    selectedCompetition: {
      set(id) {
        this.$store.dispatch('selectCompetition', id);
      },
      get(){
        return this.$store.getters['competitionId'];
      }
    },
    userFullName: function(){
      var user = this.$store.getters['user'];
      if(!user) return "";
      return user.firstName+" "+user.lastName;
    },
    items: function(){
      var isAdmin = this.$store.getters['isAdministrator'];
      var isReferee = this.$store.getters['isReferee'];
      return [
        { icon: 'dashboard', key: 'dashboard' },
        { icon: 'person', key: 'profile' },
        { icon: 'recent_actors', key: 'competitors', admin: true },
        { icon: 'folder', key: 'applications' },
        { icon: 'timer', key: 'competition', admin: true },
        { icon: 'sports', key: 'referee', admin: true, referee: true },
        { icon: 'timer', key: 'results', admin: false },
        { icon: 'developer_board', key: 'server', admin: true },
        { icon: 'call', key: 'contact', admin: false }
      ].filter(i => (!i.admin && !i.referee) || (i.admin && isAdmin) || (i.referee && isReferee));
    },
    isLocalhost: function(){
      return fccapi.baseUrl.startsWith("https://localhost");
    }
  },
  methods: {
    navigate(item) {
      this.title = this.$t(item.key+'.title')
      this.$router.push('/app/'+item.key)
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    changeLocale(locale){
      this.$i18n.locale = locale
    },
    closeErrorDialog(){
      this.$store.dispatch('reportError', null)
    },
    toggleDark() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.$store.dispatch('setDark', this.$vuetify.theme.dark);
    }
  },
  mounted: function (){
    /*if(this.$route.path.match(/\/app\/?\B/))
      this.navigate(this.items[0])*/
      console.log(this.$i18n);
  },
  components: {
    VSelect,
    VMenu,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VDialog,
    "v-progress-linear": VProgressLinear
  }
}
</script>